/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { SuccessFlag } from '../index.tsx';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export default SuccessFlag;
